module.exports = __webpack_public_path__ + "1d46597f16318813a4da5de69c9f2169.svg";